const audiences = [
  {
    icon: 'ri-user-star-line',
    number: '1',
    title: 'Экспертам, специалистам и консультантам',
    text: 'В вашей деятельности важен личный бренд? Социальные сети — это ключ к созданию непоколебимой репутации, наращиванию базы лояльных клиентов и конвертации охватов в продажи с высоким чеком.',
    tags: ['Личный бренд', 'Высокий чек', 'Репутация'],
    image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/573e641816b33f44d8259ef15bdf5213.png',
  },
  {
    icon: 'ri-building-2-line',
    number: '2',
    title: 'Предпринимателям и владельцам бизнеса',
    text: 'У вас есть продукт, и вы хотите привлекать заявки через соцсети системно? Мы внедрим проверенные механики, которые уже приносят прибыль вашим конкурентам, и адаптируем их под ваши бизнес-цели.',
    tags: ['Системные продажи', 'Рост заявок', 'Масштабирование'],
    image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/1da561194dcbdc812203ac07ec3fde9b.png',
  },
];

export default function SMMForWhom() {
  return (
    <section id="smm-for-whom" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/30 mb-5">
            <i className="ri-group-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Целевая аудитория
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Для кого эта услуга?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 sm:gap-8">
          {audiences.map((a, i) => (
            <div
              key={i}
              className="group bg-[#F9F5EF] rounded-2xl sm:rounded-3xl overflow-hidden border border-gray-100 hover:border-[#C5A880]/40 transition-all duration-300"
            >
              <div className="relative overflow-hidden bg-[#F9F5EF]">
                <img
                  src={a.image}
                  alt={a.title}
                  className="w-full h-auto object-contain group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-4 left-4 flex items-center gap-2">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#C5A880] rounded-xl flex items-center justify-center">
                    <i className={`${a.icon} text-white text-sm sm:text-base`}></i>
                  </div>
                  <span className="text-[#1A2B4C]/70 text-xs font-['Montserrat'] font-semibold">
                    #{a.number}
                  </span>
                </div>
              </div>

              <div className="p-5 sm:p-8">
                <h3 className="text-base sm:text-xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3 leading-snug">
                  {a.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-['Montserrat'] mb-4 text-justify">
                  {a.text}
                </p>
                <div className="flex flex-wrap gap-2">
                  {a.tags.map((tag, ti) => (
                    <span
                      key={ti}
                      className="text-xs font-semibold text-[#C5A880] bg-[#C5A880]/10 px-3 py-1 rounded-full font-['Montserrat']"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
